import React from 'react';

export const MemorizedModal = ({ memorized, decks, onClose, onUnmark }) => {
  const groupedByDeck = {};
  
  memorized.forEach(key => {
    const [deckName, indexStr] = key.split('|');
    const index = parseInt(indexStr);
    if (!groupedByDeck[deckName]) {
      groupedByDeck[deckName] = [];
    }
    if (decks[deckName] && decks[deckName][index]) {
      groupedByDeck[deckName].push({ card: decks[deckName][index], index });
    }
  });

  return (
    <div className="modal" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Memorized Cards</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {memorized.length === 0 ? (
            <div className="empty-state">
              No memorized cards yet.<br/><br/>
              Start marking cards as you learn them!
            </div>
          ) : (
            Object.entries(groupedByDeck).map(([deckName, cards]) => (
              <div key={deckName}>
                <div className="topic-header">{deckName}</div>
                {cards.map(({ card, index }) => (
                  <div key={index} className="memorized-item">
                    <div className="memorized-text">
                      <div className="memorized-ar">{card.ar}</div>
                      <div className="memorized-en">{card.en}</div>
                    </div>
                    <button 
                      className="btn-unmark"
                      onClick={() => onUnmark(deckName, index)}
                    >
                      Unmark
                    </button>
                  </div>
                ))}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};
